import { createStyles } from '@mantine/styles';
var useStyles = createStyles(function(_theme, param) {
    var orientation = param.orientation;
    return {
        panel: {
            flex: orientation === "vertical" ? 1 : void 0
        }
    };
});
export default useStyles; //# sourceMappingURL=TabsPanel.styles.js.map
